@if (ready()) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport="true" [attr.role]="isHandset() ? 'dialog' : 'navigation'"
      [mode]="isHandset() ? 'over' : 'side'" [opened]="!isHandset()">
      <img class="logo" src="/assets/img/logo.png" alt="logo">
      <mat-nav-list>
        @for (item of sideMenu() ; track item) {
          @if (item.type=='item' && isItemVisible(item)) {
            <a mat-list-item routerLink="{{item.path}}">
              @if (item?.icon) {
                <mat-icon class="side-menu">{{ item.icon }}</mat-icon>
              }
              <span>{{ (item.label ?? '') | translate }}</span>
            </a>
          }
          @if (item.type=='separator') {
            <hr class="separator" >
          }
        }
        <a mat-list-item (click)="auth.logout()">
          <mat-icon class="side-menu">exit_to_app</mat-icon>
          <span>{{ 'NAV.LOGOUT' | translate }}</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="primary">
        <mat-toolbar-row>
          @if (isHandset()) {
            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
              <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
          }
          <span class="page-title">{{navService.getPageTitle()}}</span>
          <span class="example-spacer"></span>
          <button mat-button [matMenuTriggerFor]="menu">
            <avatar [user]="user()" size="sm" width="50"></avatar>
          </button>
          <mat-menu #menu="matMenu">
            @for (item of profileMenu() ; track item) {
              @if (item.type=='item' && isItemVisible(item) && item.path) {
                <button mat-menu-item  routerLink="{{item.path}}">
                  @if (item?.icon) {
                    <mat-icon>{{ item.icon }}</mat-icon>
                  }
                  <span>{{ (item.label ?? '') | translate}}</span>
                </button>
              }
              @if (item.type=='item' && isItemVisible(item) && item.click) {
                <button mat-menu-item  (click)="item.click()">
                  @if (item?.icon) {
                    <mat-icon>{{ item.icon }}</mat-icon>
                  }
                  <span>{{ (item.label ?? '') | translate}}</span>
                </button>
              }
              @if (item.type=='separator') {
                <hr class="separator" >
              }
            }
            <button mat-menu-item (click)="auth.logout()">
              <mat-icon class="example-icon">exit_to_app</mat-icon>
              <span>{{ 'NAV.LOGOUT' | translate}}</span>
            </button>
          </mat-menu>
        </mat-toolbar-row>
      </mat-toolbar>
      <!-- Add Content Here -->
      <div class="router-wrapper">
        <!-- <ng-container *ngIf="user">
        <alert color="warning" [close]="true" *ngIf="!user?.complete">{{ 'ALERT.ACCOUNT_NOT_COMPLETED' | translate}}
          <mat-icon (click)="goToAccount()" class="in-alert-icon hand">arrow_right_alt</mat-icon>
        </alert>
        <alert color="warning" [close]="true" *ngIf="!user?.profile_complete">{{ 'ALERT.PROFILE_NOT_COMPLETED' | translate}}
          <mat-icon (click)="goToProfile()" class="in-alert-icon hand">arrow_right_alt</mat-icon>
        </alert>
      </ng-container> -->
      <router-outlet ></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
}

